import ConfirmButton from "features/shared/components/buttons/ConfirmButton.styled";
import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import styled from "styled-components";
import { DefaultSuccessBannerProps } from "../SuccessBannerClient";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import Body from "features/shared/styles/typography/Body.styled";

const DefaultSuccessBanner = styled.div<DefaultSuccessBannerProps>`
  border-radius: ${({ theme }) => theme.borderRadiusBanner};
  overflow: hidden;
  background-color: rgba(46, 125, 50, 0.1);
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-left: ${({ theme, direction }) =>
    theme.hasStripeOnSuccessBanner && direction === "ltr"
      ? `8px solid ${theme.colors.highlight4}`
      : "none"};
  border-right: ${({ theme, direction }) =>
    theme.hasStripeOnSuccessBanner && direction === "rtl"
      ? `8px solid ${theme.colors.highlight4}`
      : "none"};
  padding: 24px;
  display: flex;
  align-items: flex-start;

  margin-bottom: 24px;

  img {
    margin-right: ${({ direction }) => (direction === "ltr" ? "12px" : "0")};
    margin-left: ${({ direction }) => (direction === "rtl" ? "12px" : "0")};
  }

  ${PrimaryButton}, ${ConfirmButton} {
    margin-top: 24px;
  }

  ${TertiaryHeader} {
    font-size: ${({ theme }) => theme.fonts.summary.fontSize};
  }

  ${Body} {
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    flex-direction: column;
  }
`;

export default DefaultSuccessBanner;
